module.exports = __webpack_public_path__ + "static/img/1018_big.74d72f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1018_big.png
// module id = BNi/
// module chunks = 1